import { combineReducers } from 'redux';
import moment from 'moment';
import EnumsManager from 'utils/EnumsManager';
import { getStore } from 'utils/localStorage';
import {
  TASK_LIST_PAGENATIONS,
  TASK_LIST_DATA,
  TASK_LIST_PERIOD,
  TASK_STATUS,
  SET_TEAM_MEMBERS,
  TASK_SET_ACTIVE_MEMBER,
  SET_TASK_STATUS_QUERY_TEXT,
  SET_TASK_ORDER_BY_QUERY_TEXT
} from './actionType';
import { ALL_STATUS } from './config';

const { LocalStorageKeys } = EnumsManager;
const { User } = LocalStorageKeys;
const loginUser = JSON.parse(getStore(User));

const tasks = (state = [], action) => {
  const { type, ...payload } = action;
  switch (type) {
    case TASK_LIST_DATA:
      return payload.data;
    default:
      return state;
  }
};
const taskDataTablePagination = (state = { perPage: EnumsManager.DefaultPageConfigs.PageSize, currentPage: 1, total: 0 }, action) => {
  switch (action.type) {
    case TASK_LIST_PAGENATIONS:
      return {
        perPage: action.perPage,
        currentPage: action.currentPage,
        total: action.total,
      };
    default:
      return state;
  }
};
const period = (state = { start: moment().format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD'), overDue: true }, action) => {
  const { type, ...payload } = action;
  switch (type) {
    case TASK_LIST_PERIOD:
      return Object.assign({}, state, { ...payload });
    default:
      return state;
  }
};

const selectedStatus = (state = ALL_STATUS.OVERDUE_TODAY, action) => {
  const { type, status } = action;
  switch (type) {
    case TASK_STATUS:
      return status;
    default:
      return state;
  }
};

const taskStatusQueryText = (state = '', action) => {
  const { type, text } = action;
  switch (type) {
    case SET_TASK_STATUS_QUERY_TEXT:
      return text;
    default:
      return state;
  }
};

const taskOrderByQueryText = (state = '', action) => {
  const { type, text } = action;
  switch (type) {
    case SET_TASK_ORDER_BY_QUERY_TEXT:
      return text;
    default:
      return state;
  }
};

const teamMembers = (state = { members: [], activeMember: loginUser && loginUser.id ? loginUser.id : '' }, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_TEAM_MEMBERS:
      const { data } = payload;
      return {
        ...state,
        members: data
      };

    case TASK_SET_ACTIVE_MEMBER:
      const { member } = payload;
      return {
        ...state,
        activeMember: member,
      };
    default:
      return state;
  }
};

export default combineReducers({
  period,
  taskDataTablePagination,
  tasks,
  selectedStatus,
  teamMembers,
  taskStatusQueryText,
  taskOrderByQueryText
});




// WEBPACK FOOTER //
// ./src/views/Task/flow/reducer.js